import React, { Fragment, useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { history } from '../../utils/history';
import PageHeader from "../shared/page-header";
import {
    Grid,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    TableContainer,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

import { getLocationsSelector, getLocations, clearLocation, deleteLocation } from '../../store/admin';
import { TablePaginationActions } from '../shared/pagination';
import { EnhancedTableHead, stableSort, getSorting } from '../shared/tableHeader';
import EditButton from '../shared/edit-button';
import DeleteButton from '../shared/delete-button/delete-button-view';

const useStyles = makeStyles(theme => ({
    button: theme.button
}));


const LocationManagement = ({ ...props }) => {

    const classes = useStyles();      
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('id');
    const [open, setOpen] = React.useState(false);
    const [selectedLocationId, setSelectedLocationId] = React.useState(0);

    
    useEffect(() => {
        const init = async () => {
            const { getLocations, clearLocation } = props;
            await getLocations();
            clearLocation();
        }
        init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        setOpen(false);
        setSelectedLocationId(0);
    };

    const onDelete = (id) => {
        setSelectedLocationId(id);
        setOpen(true);
    }

    const handleConfirmDelete = async () => {

        const {deleteLocation, clearLocation} = props;
        await deleteLocation(selectedLocationId)
        clearLocation();
        setOpen(false);
    }

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = e => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    };    

    const handleRequestSort = (e, property) => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    };
    
    const onEdit = (id) => {
        history.push(`/location/${id}`);
    }

    const headCells = [
        { id: 'id', numeric: false, disablePadding: false, label: 'Id' },
        { id: 'name', numeric: false, disablePadding: false, label: 'Name' },
        { id: 'address', numeric: false, disablePadding: false, label: 'Address' },
        { id: 'telephone', numeric: false, disablePadding: false, label: 'Telephone' },
        { id: 'fax', numeric: false, disablePadding: false, label: 'Fax' },
        { id: 'email', numeric: false, disablePadding: false, label: 'Email' },
        { id: 'edit', numeric: false, disablePadding: false, label: '' },
        { id: 'delete', numeric: false, disablePadding: false, label: '' },
    ];
    
    return (
        <Fragment>
            <PageHeader
                title="Locations"
                description="Manage clinic locations."
                action={
                    <Button variant="contained" type="button" color="secondary" onClick={e => history.push(`/location/new`)}>Add Location</Button>
                }
            />
            { props.locations &&
                <Grid item xs={12} style={{overflow: "auto"}}>
                    
                    <TableContainer>
                        <Table 
                            className={classes.table}
                            size="small"
                            aria-labelledby="locations"
                            aria-label="enhanced table">
                                <EnhancedTableHead
                                    classes={classes}
                                    order={order}
                                    orderBy={orderBy}
                                    onRequestSort={handleRequestSort}
                                    rowCount={props.locations.length}
                                    headCells={headCells}
                                    />
                                <TableBody>
                                    {stableSort(props.locations, getSorting(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map(location => {
                                            return (
                                                <TableRow key={location.id}  className={classes.tableRow}>
                                                    <TableCell component="th" scope="row" >{location.id}</TableCell>
                                                    <TableCell component="th" scope="row" >{location.name}</TableCell>
                                                    <TableCell component="th" scope="row" >{location.address}</TableCell>
                                                    <TableCell component="th" scope="row" >{location.telephone}</TableCell>
                                                    <TableCell component="th" scope="row" >{location.fax}</TableCell>
                                                    <TableCell component="th" scope="row" >{location.email}</TableCell>
                                                    <TableCell component="th" scope="row" ><EditButton pid={location.id} handleEdit={onEdit} /></TableCell>
                                                    <TableCell component="th" scope="row" ><DeleteButton pid={location.id} handleDelete={onDelete} /></TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                        </Table>                    
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25,100]}
                        component="div"
                        count={props.locations.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        SelectProps={{
                            inputProps: { 'aria-label': 'rows per page' },
                            native: true,
                        }}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                    />
                </Grid>   
            }
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete Location"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete selected location?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button variant="contained" onClick={handleConfirmDelete} color="primary">
                    Yes
                </Button>
                <Button variant="contained" onClick={handleClose} color="primary" autoFocus>
                    No
                </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );    
}

const mapStateToProps = state => {

    return {
        locations: getLocationsSelector(state)
    };

};

const mapDispatchToProps = dispatch => {
    return {
        ...bindActionCreators({ getLocations, clearLocation, deleteLocation }, dispatch)   
    }
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LocationManagement)